import { gql } from 'apollo-boost';

import { HolidaySummary } from '../interfaces/holidaySummary';
import { Resource } from './resource';

export class DayOffResource extends Resource {
  public static async list(variables: { month?: number; year?: number; userId?: number }) {
    return await this.query({
      query: gql`
        query($month: Int, $year: Int, $userId: Int) {
          dayoffs(month: $month, year: $year, userId: $userId, status: true) {
            id
            userId
            accepted
            hrAccept
            managerAccept
            reason
            items {
              date
            }
            user {
              id
              firstName
              lastName
            }
            absenceId
            absence {
              id
              name
            }
            hourStart
            minuteStart
            hourEnd
            minuteEnd
          }
          holidays(month: $month, year: $year) {
            date
            name
            color
          }
        }
      `,
      variables
    });
  }

  public static async accept(id: number) {
    return await this.mutation(
      {
        mutation: gql`
          mutation($id: Int!) {
            acceptDayOff(id: $id) {
              id
              accepted
              absenceId
            }
          }
        `,
        variables: { id }
      },
      'acceptDayOff'
    );
  }

  public static async acceptAbsence(id: number, absenceId: number) {
    return await this.mutation(
      {
        mutation: gql`
          mutation($id: Int!, $absenceId: Int) {
            acceptAbsence(id: $id, absenceId: $absenceId) {
              id
              accepted
              absenceId
              hrAccept
            }
          }
        `,
        variables: { id, absenceId }
      },
      'acceptAbsence'
    );
  }

  public static async deleteDayOff(id: number) {
    return await this.mutation(
      {
        mutation: gql`
          mutation($id: Int!) {
            deleteDayOff(id: $id) {
              id
            }
          }
        `,
        variables: { id }
      },
      'deleteDayOff'
    );
  }

  public static async add(form: any, userId: number, absenceId: number) {
    return await this.mutation(
      {
        mutation: gql`
          mutation(
            $dateStart: DateTime!
            $dateEnd: DateTime!
            $reason: String
            $userId: Int
            $absenceId: Int
            $hourStart: Int
            $minuteStart: Int
            $hourEnd: Int
            $minuteEnd: Int
          ) {
            addDayOffs(
              dayOff: {
                dateStart: $dateStart
                dateEnd: $dateEnd
                reason: $reason
                hourStart: $hourStart
                minuteStart: $minuteStart
                hourEnd: $hourEnd
                minuteEnd: $minuteEnd
              }
              userId: $userId
              absenceId: $absenceId
            ) {
              id
              userId
              accepted
              hrAccept
              managerAccept
              reason
              items {
                date
              }
              user {
                id
                firstName
                lastName
              }
              absence {
                id
                name
              }
              absenceId
              hourStart
              minuteStart
              hourEnd
              minuteEnd
            }
          }
        `,
        variables: {
          dateStart: form.$model.dateStart,
          dateEnd: form.$model.dateEnd,
          reason: form.$model.reason,
          hourStart: form.$model.hourStart,
          minuteStart: form.$model.minuteStart,
          hourEnd: form.$model.hourEnd,
          minuteEnd: form.$model.minuteEnd,
          userId,
          absenceId
        }
      },
      'addDayOffs'
    );
  }

  public static async update(id: number, form: any, absenceId: number) {
    return await this.mutation(
      {
        mutation: gql`
          mutation(
            $id: Int!
            $dateStart: DateTime!
            $dateEnd: DateTime!
            $reason: String
            $absenceId: Int
            $hourStart: Int
            $minuteStart: Int
            $hourEnd: Int
            $minuteEnd: Int
          ) {
            updateDayOff(
              id: $id
              dayOff: {
                dateStart: $dateStart
                dateEnd: $dateEnd
                reason: $reason
                hourStart: $hourStart
                minuteStart: $minuteStart
                hourEnd: $hourEnd
                minuteEnd: $minuteEnd
              }
              absenceId: $absenceId
            ) {
              id
              userId
              accepted
              hrAccept
              managerAccept
              reason
              items {
                date
              }
              user {
                id
                firstName
                lastName
              }
              absenceId
              hourStart
              minuteStart
              hourEnd
              minuteEnd
            }
          }
        `,
        variables: {
          id,
          dateStart: form.$model.dateStart,
          dateEnd: form.$model.dateEnd,
          reason: form.$model.reason,
          hourStart: form.$model.hourStart,
          minuteStart: form.$model.minuteStart,
          hourEnd: form.$model.hourEnd,
          minuteEnd: form.$model.minuteEnd,
          absenceId
        }
      },
      'updateDayOff'
    );
  }

  public static async holidaySummary(variables: { year?: number }): Promise<HolidaySummary[]> {
    return await this.query({
      query: gql`
        query($year: Int) {
          dayOffHolidaySummary(year: $year) {
            userId
            lastName
            firstName
            total
            acceptedManager
            acceptedHr
            used
          }
        }
      `,
      variables
    }).then(data => data.dayOffHolidaySummary);
  }
}
